<div [ngClass]="{ 'linked': !!valueConfig?.link, 'cloud-link': !!valueConfig?.link }" (click)="onClick()" class="ml-3 mt-1 row">
  <div class="avatar">
    <span class="avatar-inner-text">{{ createAvatarText(value) }}</span>
  </div>
  <div class="avatar-text">
    <span class="text-center">{{ value }}</span>
  </div>
</div>
